'use client';

import { useEffect } from 'react';

import { Error as ErrorComponent } from '@app/_components/error/Error';
import { useSentry } from '@hooks/useSentry';

import type { FC } from 'react';

type Props = Readonly<{
  error: Error;
  digest?: string;
}>;

const GlobalError: FC<Props> = ({ error }) => {
  const { captureException } = useSentry();

  useEffect(() => {
    captureException(error);
  }, [captureException, error]);

  return (
    <html>
      <body>
        <ErrorComponent />
      </body>
    </html>
  );
};

export default GlobalError;
